export const formatDuration = (durationInSeconds) => {
  const h = Math.floor(durationInSeconds / 3600);
  const m = Math.floor(durationInSeconds / 60) - h * 60;
  const s = Math.floor(durationInSeconds) - m * 60 - h * 3600;
  const hh = h < 10 ? `0${h}` : `${h}`;
  const mm = m < 10 ? `0${m}` : `${m}`;
  const ss = s < 10 ? `0${s}` : `${s}`;

  return `${hh}:${mm}:${ss}`;
};

export const formatDurationMinAndSeconds = (durationInSeconds) => {
  const format = formatDuration(durationInSeconds);
  return format.substring(3);
};

export const getCurrentDayString = () => {
  const day = new Date().getDay();
  return getDayString(day);
};

export const getDayString = (day: number) => {
  return [
    'dimanche',
    'lundi',
    'mardi',
    'mercredi',
    'jeudi',
    'vendredi',
    'samedi',
  ][day];
};

export const getMonths = () => {
  return [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ];
};

export const getCurrentMonthString = () => {
  const month = new Date().getMonth();
  return getMonths()[month];
};

export const getFormatedBirthDate = (date: string) => {
  const year = date.slice(0, 4);
  const month = getMonths()[Number(date.slice(5, 7)) - 1];
  const day = date.slice(8, 10);
  return `${day} ${month} ${year}`;
};

export const getCurrentDayDateString = () => {
  return `${getCurrentDayString()} ${new Date().getDate()} ${getCurrentMonthString()}`;
};

export const getFormatedDuration = (timeInMinutes: number) => {
  const h = Math.floor(timeInMinutes / 60);
  const m = timeInMinutes - h * 60;
  const hh = h > 0 ? `${h}h` : ``;
  const mm = h > 0 ? (m > 0 ? `${m}min` : ``) : `${m}min`;

  return `${hh} ${mm}`;
};

export const getToDayDate = () => {
  const date = new Date();
  const day = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  ).toString();

  return day;
};

export const getToDayDateIso = () => {
  const date = new Date();
  const day = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  ).toISOString();

  return day;
};

export const getPreviousDayDateIso = (dateIso) => {
  const date = new Date(dateIso);
  const day = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() - 1)
  ).toISOString();
  return day;
};

export const getNextDayDateIso = (dateIso) => {
  const date = new Date(dateIso);
  const day = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 1)
  ).toISOString();
  return day;
};

export const getTimeLeft = (dateIso) => {
  const date = new Date(dateIso).getTime();
  return date - new Date().getTime();
};

export const getDaysLeft = (dateIso) => {
  let daysLeft = getTimeLeft(dateIso);
  daysLeft = Math.floor(daysLeft / 1000 / 60 / 60 / 24);
  return daysLeft > 0 ? daysLeft : 0;
};

export const getFormatedDateCalendar = (dateIso) => {
  const date = new Date(dateIso);
  return `${getDayString(date.getDay())} ${date.getUTCDate()} ${
    getMonths()[date.getMonth()]
  } ${date.getFullYear()}`;
};

export const getClockTime = (dateIso) => {
  const date = new Date(dateIso);
  const min =
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`;
  return `${date.getHours()}:${min}`;
};

export const getEventDateToLocaleString = (
  strDateStart: string,
  strDateEnd?: string
) => {
  if (!strDateEnd) strDateEnd = strDateStart;
  const dateStart = new Date(strDateStart);
  const dateEnd = new Date(strDateEnd);
  if (strDateEnd.slice(0, 10) === strDateStart.slice(0, 10)) {
    // 1 day
    return dateStart.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } else if (dateStart.getFullYear() !== dateEnd.getFullYear()) {
    // du 11 mai 2025 au 8 mai 2026
    return `Du ${dateStart.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })} au ${dateEnd.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}`;
  } else if (dateStart.getMonth() !== dateEnd.getMonth()) {
    // du 11 mai au 28 mai 2025
    return `Du ${dateStart.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
    })} au ${dateEnd.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}`;
  } else {
    return `Du ${dateStart.toLocaleDateString('fr-FR', {
      day: 'numeric',
    })} au ${dateEnd.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}`;
  }
};

export const getEventDaysHourToLocaleString = (
  strDateStart: string,
  strDateEnd?: string
) => {
  if (!strDateEnd) strDateEnd = strDateStart;
  const dateStart = new Date(strDateStart);
  const dateEnd = new Date(strDateEnd);

  const hourStart = dateStart.toLocaleString('fr-FR', {
    timeStyle: 'short',
  });
  const hourEnd = dateEnd.toLocaleString('fr-FR', {
    timeStyle: 'short',
  });

  const dayStart = dateStart.toLocaleDateString('fr-FR', {
    weekday: 'long',
  });

  const dayEnd = dateEnd.toLocaleDateString('fr-FR', {
    weekday: 'long',
  });

  if (strDateEnd.slice(0, 10) === strDateStart.slice(0, 10)) {
    // same day
    return `${dayStart}, ${hourStart} - ${hourEnd}`;
  } else {
    // du 11 mai 2025 au 8 mai 2026
    return `${dayStart}, ${hourStart} - ${dayEnd}, ${hourEnd}`;
  }
};

export const getEventHourToLocaleString = (
  strDateStart: string,
  strDateEnd?: string
) => {
  if (!strDateEnd) strDateEnd = strDateStart;
  const dateStart = new Date(strDateStart);
  const dateEnd = new Date(strDateEnd);

  const hourStart = dateStart.toLocaleString('fr-FR', {
    timeStyle: 'short',
  });
  const hourEnd = dateEnd.toLocaleString('fr-FR', {
    timeStyle: 'short',
  });

  return `${hourStart} à ${hourEnd}`;
};

export const isSameDay = (strDate: string) => {
  const date = new Date(strDate);
  const testedDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  const toDayDate = new Date();
  const toDay = new Date(
    toDayDate.getFullYear(),
    toDayDate.getMonth(),
    toDayDate.getDate()
  );

  return toDay.getTime() - testedDate.getTime() === 0;
};
